import React from 'react';

import { Alert, Box } from '@mui/material';

import { type WpRendererError } from '@waypoint/templates';

const BACKGROUND_SX = {
  display: 'flex',
  justifyContent: 'center',
  bgcolor: 'rgba(255, 255, 255, 0.25)',
  position: 'absolute',
  top: 48,
  left: 0,
  right: 0,
  bottom: 0,
  transition: 'background-color 0.2s',
};

type Props = {
  subjectError: WpRendererError | null;
  preheaderError: WpRendererError | null;
};
export default function ErrorMessages({ subjectError, preheaderError }: Props) {
  if (!subjectError && !preheaderError) {
    return null;
  }
  return (
    <Box sx={BACKGROUND_SX}>
      <Box sx={{ position: 'absolute', top: 0, zIndex: 'snackbar', left: 0, right: 0 }}>
        {renderAlert('Error in subject: ', subjectError)}
        {renderAlert('Error in preheader: ', preheaderError)}
      </Box>
    </Box>
  );
}

function renderAlert(label: string, error: WpRendererError | null) {
  if (error === null) {
    return null;
  }
  return (
    <Alert variant="filled" severity="error">
      {label} {error.message}
    </Alert>
  );
}
